import WhyChooseUS from '@/components/common/WhyChooseUs';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const Services = ({ isHome }) => {
  const navigate = useNavigate();
  // for test
  const services = [
    {
      icon: '/corporate-security.jpg',
      title: 'Corporate Security',
      link: '/corporate-security',
      desc: 'Professional guards for your office premises and business centers, ensuring safety and peace of mind.',
    },
    {
      icon: '/concierge.png',
      title: 'Concierge Services',
      link: '/concierge-services',
      desc: 'Friendly and professional concierge staff assisting your guests, visitors, and employees efficiently.',
    },
    {
      icon: '/constructionsecurity.png',
      title: 'Construction Security & Services',
      link: '/construction-security-services',
      desc: 'Expert security personnel safeguarding your construction sites, equipment, and materials around the clock.',
    },

    {
      icon: '/remotemonitoring.jpg',
      title: 'Remote and CCTV Monitoring',
      link: '/remote-monitoring',
      desc: 'We provide 24/7 remote and CCTV monitoring services to keep your property secure and under constant watch.',
    },
    {
      icon: '/industrialwarehouse.jpg',
      title: 'Industrial & Warehouse Security & Services',
      link: '/industrial-warehouse-security',
      desc: 'We provide you a real-time view of current active and invited Business users. This original product provides the perfect blank canvas...',
    },
    {
      icon: '/mobilepatrols.jpg',
      title: 'Mobile Patrols',
      link: '/mobile-patrols',
      desc: 'If your post contains audio, then you should use this post format. Select Audio in the appeared metabox and add',
    },
    {
      icon: '/cleaning-security.png',
      title: 'Cleaning Services',
      link: '/cleaning-services',
      desc: 'For some businesses, the most advanced security features they require are the door chimes and stickers warning of security',
    },
    {
      icon: '/hotelporter.avif',
      title: 'Hotel Porter Services',
      link: '/hotel-porter-services',
      desc: 'For some businesses, the most advanced security features they require are the door chimes and stickers warning of security',
    },
    {
      icon: '/eventsecurity.webp',
      title: 'Event Security',
      link: '/event-security',
      desc: 'The security needs of a business differ greatly depending on several different factors, including location, the type of business',
    },
    {
      icon: '/retailsecurity.webp',
      title: 'Retail Security',
      link: '/retail-security',
      desc: 'We support the Security Assertion Markup Language (SAML) for single sign-on (SSO) for your Business users',
    },
    {
      icon: '/studentsaccommodation.png',
      title: 'Students Accommodation Associates (CSA)',
      link: '/students-accommodation',
      desc: 'We provide trusted student accommodation services through CSA, offering safe, affordable, and well-managed housing solutions.',
    },
    {
      icon: '/unoccupiedproperty.jpg',
      title: 'Unoccupied Property Monitoring',
      link: '/unoccupied-property-monitoring',
      desc: 'Dedicated personnel to monitor and protect unoccupied properties, reducing risk of theft, vandalism, or unauthorized access.',
    },
  ];

  return (
    <>
      {!isHome && (
        <div className="mt-[6rem] flex w-full justify-center py-[2.5rem] font-inter md:py-[4rem]">
          <div className="flex w-full max-w-[114rem] flex-col items-stretch justify-center gap-[4rem] px-[2rem]">
            {/* ===== HEADING ===== */}
            <div className="flex flex-col items-center text-center">
              <h1 className="pt-[4rem] text-[3.6rem] font-[600] leading-[4.65rem] text-white md:pt-[6rem] lg:pt-[10rem]">
                Services
              </h1>
              <h1 className="mb-[2rem] mt-[2rem] max-w-[70rem] text-[1.8rem] font-[400] leading-[2.4rem] text-[#828FA0]">
                Our adaptive and future focused approach makes us the optimal choice of our clients
                in security. Our focus is not only on understanding our client’s needs and
                expectations but also their satisfaction.
              </h1>
            </div>{' '}
          </div>{' '}
        </div>
      )}
      <div className="mt-[3rem] flex w-full justify-center py-[4rem] font-inter md:mt-[4rem] lg:mt-[6rem]">
        <div className="flex w-full max-w-[114rem] flex-col items-stretch justify-center gap-[4rem] px-[2rem]">
          {/* ===== HEADING ===== */}
          <div className="flex flex-col items-center text-center">
            <h1 className="mb-[2rem] text-[1.8rem] font-[500] leading-[1.8rem] text-[#0EC9AC]">
              Our Services
            </h1>
            <h1 className="text-[3.6rem] font-[600] leading-[4.65rem] text-white">What We Offer</h1>
          </div>

          {/* ===== SMALL SERVICES GRID ===== */}
          <div className="grid w-full grid-cols-1 gap-[2rem] sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3">
            {services.map((item, index) => (
              <motion.div
                key={index}
                className="flex flex-col items-center justify-start gap-3 rounded-xl bg-[#011936] p-6 py-[3rem] text-center transition"
                initial={{ opacity: 0, y: 50 }} // start slightly below
                whileInView={{ opacity: 1, y: 0 }} // animate to original position
                viewport={{ once: true, amount: 0.5 }} // trigger when 50% visible
                transition={{ duration: 0.8 }} // stagger animation
              >
                <img
                  src={item.icon}
                  alt={item.title}
                  className="aspect-[1.7] w-[70%] rounded-md object-cover"
                />
                <h3 className="py-[1rem] text-[1.8rem] font-[600] leading-[2.7rem] text-white">
                  {item.title}
                </h3>
                <p className="text-[1.6rem] font-[400] leading-[2.4rem] text-[#828FA0]">
                  {item.desc}
                </p>
                <div
                  onClick={() => {
                    navigate(`${item.link}`);
                  }}
                  className="mt-[2rem] flex w-full cursor-pointer items-center justify-center gap-[1rem] text-[#0EC9AC]"
                >
                  <h1 className="text-[1.2rem] font-[600] leading-[100%]">READ MORE</h1>
                  <ArrowRight className="h-auto w-[1.6rem] text-[1.2rem]" />
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
      {!isHome && <WhyChooseUS />}
    </>
  );
};
